import { Injectable } from '@angular/core';
import { AppConfigService } from './app-config.service';
import { HttpClient } from '@angular/common/http';
import { map } from 'rxjs/operators';
import { Patient } from '../models/patient';
import { PatientUpdate } from '../models/patientUpdate';
import { CommentaireSurPatient } from '../models/CommentaireSurPatient';
import {Support} from '../models/Support';
import {SupportOffline} from '../models/SupportOffline';
import {StorageService} from './storage.service';
import {PatientService} from './patient.service';
import {Router} from '@angular/router';

@Injectable()
export class CurrentPatientService {

  constructor(private storageService: StorageService,
              private patientService: PatientService,
              private router: Router) {}

  putFirstPatientAsCurrent() {
      if (localStorage.getItem('patientId') !== localStorage.getItem('firstPatientId')) {
          this.storageService.setItem('patientId', localStorage.getItem('firstPatientId'));
          this.patientService.getPatient(parseInt(localStorage.getItem('firstPatientId'))).toPromise().then((patient) => {
              this.storageService.setItem('patientCurrent', JSON.stringify(patient));
          });
      }
  }

  updateCurrentPatient(patientId: number) {
      this.storageService.setItem('patientId', patientId.toString());
      this.patientService.getPatient(patientId).toPromise().then((patient) => {
          this.storageService.setItem('patientCurrent', JSON.stringify(patient));
          this.router.navigate(['/associated-profiles/' + patientId]);
      });
  }
}
